export const commonTranslations = {
  cancel: {
    key: 'common.cancel',
    defaultValue: 'Cancel',
  },
  close: {
    key: 'common.close',
    defaultValue: 'Close',
  },
  back: {
    key: 'common.back',
    defaultValue: 'Back',
  },
  yes: {
    key: 'common.yes',
    defaultValue: 'Yes',
  },
  no: {
    key: 'common.no',
    defaultValue: 'No',
  },
  you: {
    key: 'common.you',
    defaultValue: 'You',
  },
  create: {
    key: 'common.create',
    defaultValue: 'Create',
  },
  update: {
    key: 'common.update',
    defaultValue: 'Update',
  },
  read: {
    key: 'common.read',
    defaultValue: 'Read',
  },
  delete: {
    key: 'common.delete',
    defaultValue: 'Delete',
  },
  selectedFilters: {
    key: 'common.selectedFilters',
    defaultValue: 'Filters Selected:',
  },
  tryAgain: {
    key: 'common.tryAgain',
    defaultValue: 'Try Again',
  },
  checking: {
    key: 'common.checking',
    defaultValue: 'Checking...',
  },
  home: {
    key: 'common.home',
    defaultValue: 'Go Home',
  },
  confirm: {
    key: 'common.confirm',
    defaultValue: 'Confirm',
  },
  errorText1: {
    key: 'common.errorText1',
    defaultValue: 'Oops!',
  },
  errorText2: {
    key: 'common.errorText2',
    defaultValue: 'Something went wrong!',
  },
  errorText3: {
    key: 'common.errorText3',
    defaultValue: 'Please try again later.',
  },
  successText: {
    key: 'common.successText',
    defaultValue: 'Success!',
  },
  loading: {
    key: 'common.loading',
    defaultValue: 'Loading Store Performance Application with insights...',
  },
  loadMore: {
    key: 'common.loadMore',
    defaultValue: 'Load More',
  },
  next: {
    key: 'common.next',
    defaultValue: 'Next',
  },
  complete: {
    key: 'common.complete',
    defaultValue: 'Complete',
  },
  mon: {
    key: 'common.monday',
    defaultValue: 'Monday',
  },
  tue: {
    key: 'common.tuesday',
    defaultValue: 'Tuesday',
  },
  wed: {
    key: 'common.wednesday',
    defaultValue: 'Wednesday',
  },
  thu: {
    key: 'common.thursday',
    defaultValue: 'Thursday',
  },
  fri: {
    key: 'common.friday',
    defaultValue: 'Friday',
  },
  sat: {
    key: 'common.saturday',
    defaultValue: 'Saturday',
  },
  sun: {
    key: 'common.sunday',
    defaultValue: 'Sunday',
  },
  pieces: {
    key: 'common.pieces',
    defaultValue: 'pieces',
  },
  allFilters: {
    key: 'common.allFilters',
    defaultValue: 'All Filters',
  },
  map: {
    google: {
      key: 'common.map.google',
      defaultValue: 'Google',
    },
    tencent: {
      key: 'common.map.tencent',
      defaultValue: 'Tencent',
    },
  },
  fromDate: {
    key: 'common.fromDate',
    defaultValue: 'From Date',
  },
  toDate: {
    key: 'common.toDate',
    defaultValue: 'To Date',
  },
  total: {
    key: 'common.total',
    defaultValue: 'Total',
  },
  metric: {
    key: 'common.metric',
    defaultValue: 'Metric',
  },
  sortBy: {
    key: 'common.sortBy',
    defaultValue: 'Sort By',
  },
  action: {
    key: 'common.action',
    defaultValue: 'Action',
  },
  copy: {
    key: 'common.copy',
    defaultValue: 'Copy',
  },
  copied: {
    key: 'common.copied',
    defaultValue: 'Copied!',
  },
  reset: {
    key: 'common.reset',
    defaultValue: 'Reset',
  },
  retry: {
    key: 'common.retry',
    defaultValue: 'Retry',
  },
};
